import FormComp from '../FormComp';
import styles from './SquareAdmis.module.css';

import axios from 'axios';
import { formatCPF } from '../../Funcoes/FormatCPF';
import { toast } from 'react-toastify';
import { formatTelefone } from '../../Funcoes/FormatTelefone';
import { useEffect, useRef, useState } from 'react';
import Overlay from '../Overlay';
import Modal from '../Utils/Modal';
import SmallLoading from '../Utils/SmallLoading';
import Formulario from '../Utils/Formulario';
import useApi from '../../hooks/useApi';
import { useModal } from '../../contexts/ModalContext';

const MSG_BLOQUEIO_RH = 'Não é possível registrar admissão, favor entrar em contato com o RH matriz.';

const formatDateBr = (isoDate) => {
    if (!isoDate) return '';
    const parts = String(isoDate).split('-');
    if (parts.length !== 3) return String(isoDate);
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
};

/* Modal de cadastro / edição de processo de admissão. Quando editingId vem
   preenchido, o modal busca os dados completos no banco via GetProcessoInfo
   e usa o endpoint EditAdmissao no submit. Para criação não recebe id. */
const SquareAdmis = ({ obras, functions, lideres, onClose, getNewValues, editingId }) => {

    const api = useApi();
    const { closeModal } = useModal();

    const editing = !!editingId;

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            closeModal();
        }
    };

    const [ loading, setLoading ] = useState( false );

    const estadosBrasil = [
        "AC", "AL", "AP", "AM", "BA", "CE", "ES", "GO", "MA", "MT",
        "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS",
        "RO", "RR", "SC", "SP", "SE", "TO"
    ];

    const [ municipios, setMunicipios ] = useState([])
    const [ emCarencia, setEmCarencia ] = useState( false );
    const [ carenciaAte, setCarenciaAte ] = useState( null );
    const [ bloqueado, setBloqueado ] = useState( false );

    const [formValues, setFormValues] = useState({
        centroCusto: "",
        nome: "",
        cpf: "",
        dataNasc: "",
        funcao: "",
        desist: "",
        prevCheg: "",
        obs: "",
        solicitante: "",
        telefone: "",
        estadoFrom: "",
        municipFrom: "",
        recebCurriculo: "",
        dataContato: "",
        chegada: "",
        exameAdm: "",
        docAdm: "",
        docSesmt: "",
        admissao: "",
        cadPortal: "",
        integracao: "",
        entradaSite: "",
        salario: "",
        numUniforme: "",
        numCalcado: ""
    })

    const clearValues = () => {

        setFormValues({
            centroCusto: "",
            nome: "",
            cpf: "",
            dataNasc: "",
            funcao: "",
            desist: "",
            prevCheg: "",
            obs: "",
            telefone: "",
            estadoFrom: "",
            municipFrom: "",
            recebCurriculo: "",
            dataContato: "",
            chegada: "",
            exameAdm: "",
            docAdm: "",
            docSesmt: "",
            admissao: "",
            cadPortal: "",
            integracao: "",
            entradaSite: "",
            salario: "",
            numUniforme: "",
            numCalcado: ""
        })

        setEmCarencia(false)
        setCarenciaAte(null)
        setBloqueado(false)

    }

    const handleChange = ( value, name ) => {

        if (name === "salario") {
            value = value.replace(/\D/g, ""); // Remove tudo que não for número
            value = value ? parseInt(value, 10) : 0; // Converte para inteiro (centavos)
            value = (value / 100).toFixed(2); // Formata para decimal
        }

        setFormValues( prev => ({

            ...prev,
            [name]: value

        }))

    }

    /* Quando carregamos um registro existente via editingId, o estadoFrom e o
       municipFrom chegam juntos. Como o useEffect abaixo dispara um fetch das
       cidades sempre que estado muda (e limpa o município no caminho do user),
       guardamos a cidade vinda do banco aqui e restauramos depois que o IBGE
       retorna a lista — assim o select consegue exibir o valor selecionado. */
    const pendingMunicipRef = useRef(null);

    useEffect(() => {

        if (!editingId) return;

        const fetchProcesso = async () => {

            setLoading(true);

            try {

                const { data } = await api.post('/Painel/API/GetProcessoInfo/', {
                    id: editingId,
                    motivo: 'ADMISSAO'
                })

                pendingMunicipRef.current = data.municip_origem ?? '';

                setFormValues({
                    centroCusto: data.centro_custo ?? '',
                    nome: data.nome ?? '',
                    cpf: data.cpf ?? '',
                    dataNasc: data.data_nasc ?? '',
                    funcao: data.funcao ?? '',
                    desist: data.desistencia ?? '',
                    prevCheg: data.prev_chegada ?? '',
                    obs: data.observacoes ?? '',
                    solicitante: data.solicitante ?? '',
                    telefone: data.telefone ?? '',
                    estadoFrom: data.estado_origem ?? '',
                    municipFrom: '',
                    recebCurriculo: data.receb_curriculo ?? '',
                    dataContato: data.data_contato ?? '',
                    chegada: data.data_chegada ?? '',
                    exameAdm: data.data_exame ?? '',
                    docAdm: data.data_doc_adm ?? '',
                    docSesmt: data.data_doc_sesmt ?? '',
                    admissao: data.data_admissao ?? '',
                    cadPortal: data.data_cad_portal ?? '',
                    integracao: data.data_integracao ?? '',
                    entradaSite: data.data_entrada_site ?? '',
                    salario: data.salario ?? '',
                    numUniforme: data.num_uniforme ?? '',
                    numCalcado: data.num_calcado ?? '',
                    id: data.id
                })

            } catch (error) {

                console.log(error)

            } finally {

                setLoading(false)

            }

        }

        fetchProcesso();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editingId])

    useEffect(() => {

        /* Só limpa o município se a mudança veio do usuário (sem ref pendente).
           Quando viemos da carga inicial, restauramos depois que IBGE responde. */
        if (pendingMunicipRef.current === null) {
            setFormValues(prev => ({ ...prev, municipFrom: '' }))
        }

        const searchMunicip = async () => {

            try{

                const { data } = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${ formValues.estadoFrom }/municipios`)
                
                setMunicipios( data.map(( obj ) => (
                    obj.nome.toUpperCase()
                )))

            }catch( error ){

                console.log(error)

            }finally{

                if (pendingMunicipRef.current !== null) {
                    const restore = pendingMunicipRef.current;
                    pendingMunicipRef.current = null;
                    setFormValues(prev => ({ ...prev, municipFrom: restore }))
                }

            }

        }

        if( formValues.estadoFrom ){

            searchMunicip();

        }else{

            setMunicipios([])

        }

    },[ formValues.estadoFrom ])

    const handleSubmit = async (e) => {

        e.preventDefault()

        if (bloqueado) {
            toast.error(MSG_BLOQUEIO_RH);
            return;
        }

        const endpointApi = editing ? '/Painel/API/EditAdmissao/' : '/Painel/API/SaveAdmissao/'

        try{

            const { data } = await toast.promise(
                api.post( endpointApi, formValues ),
                {
                    pending: 'SALVANDO INFORMAÇÕES',
                    success: 'DADOS SALVOS COM SUCESSO',
                    error: {
                        render({ data: err }) {
                            const msg = err?.response?.data?.message;
                            return msg || 'FALHA AO SALVAR DADOS';
                        }
                    }
                }
            )

            console.log( data );

            await getNewValues();
            clearValues();
            handleClose();

        }catch( error ){

            if (error?.response?.data?.bloqueado) {
                setBloqueado(true);
            }
            console.log(error.message);

        }

    }

    useEffect(() => {

        const checkCpfCarencia = async () => {
            try{
                const { data } = await api.post('/Painel/API/Admissao/CheckCpfCarencia/', {
                    cpf: formValues.cpf
                })
                setEmCarencia(data.carencia === true);
                setCarenciaAte(data.carencia_ate ?? null);
                setBloqueado(data.bloqueado === true);
            }catch(e){
                console.error(e);
                setEmCarencia(false);
                setCarenciaAte(null);
                setBloqueado(false);
            }
        }

        if( formValues.cpf.length === 11 ){
            checkCpfCarencia();
        }else{
            setEmCarencia( false );
            setCarenciaAte( null );
            setBloqueado( false );
        }

    }, [ formValues.cpf, api ])

    return (
        <Overlay state={true}>
        <Modal
            header
            noPadding
            close={() => {
            clearValues();
            handleClose();
        }}>
        <div className={styles.container} >
            <div className={styles.formContainer} >
                <Formulario onSubmit={handleSubmit}>
                    <FormComp
                        title="CENTRO CUSTO"
                        type="select"
                        options={obras}
                        valor={ formValues.centroCusto }
                        changeFunc={ (e) => handleChange( e.target.value, 'centroCusto' ) }
                    />
                    <FormComp
                        title="NOME"
                        type="text"
                        valor={ formValues.nome }
                        changeFunc={ (e) => { 

                            let value = e.target.value;
                            value = value.toUpperCase() 

                            handleChange( value, 'nome' )
                        }}
                    />
                    <FormComp
                        title="CPF"
                        type="text"
                        placeholder="Ex: 123.456.789-00"
                        valor={ formatCPF( formValues.cpf ) }
                        changeFunc={ (e) => {

                            let value = e.target.value;
                            value = value.replace(/\D/g, '');

                            handleChange( value, 'cpf' )
                        }}
                    />
                    {emCarencia && !bloqueado && (
                        <div className={styles.carenciaAviso} role="alert">
                            Este colaborador está em período de carência
                            {carenciaAte
                                ? ` até ${formatDateBr(carenciaAte)}.`
                                : '.'}
                            {' '}A admissão pode ser registrada, mas recomenda-se contato com o RH matriz.
                        </div>
                    )}
                    {bloqueado && (
                        <div className={styles.carenciaAviso} role="alert">
                            {MSG_BLOQUEIO_RH}
                        </div>
                    )}
                    <FormComp
                        title="DATA DE NASCIMENTO"
                        type="date"
                        valor={ formValues.dataNasc }
                        changeFunc={ (e) => handleChange( e.target.value, 'dataNasc' ) }
                    />
                    <FormComp
                        title="FUNÇÃO"
                        type="select"
                        options={functions}
                        valor={ formValues.funcao }
                        changeFunc={ (e) => handleChange( e.target.value, 'funcao' ) }
                    />
                    <FormComp
                        title="DESISTENCIA"
                        type="select"
                        options={["SIM"]}
                        valor={ formValues.desist }
                        changeFunc={ (e) => handleChange( e.target.value, 'desist' ) }
                    />
                    <FormComp
                        title="PREVISÃO DE CHEGADA"
                        type="date"
                        valor={ formValues.prevCheg }
                        changeFunc={ (e) => handleChange( e.target.value, 'prevCheg' ) }
                    />
                    <FormComp
                        title="OBSERVAÇÕES"
                        type="textarea"
                        valor={ formValues.obs }
                        changeFunc={ (e) => handleChange( e.target.value, 'obs' ) }
                    />
                    <FormComp
                        title="SOLICITANTE"
                        type="select"
                        obj
                        options={ lideres ?? [] }
                        valor={ formValues.solicitante }
                        changeFunc={ (e) => handleChange( e.target.value, 'solicitante' ) }
                    />
                    <FormComp
                        title="TELEFONE"
                        type="text"
                        placeholder="Ex: (11) 99999-9999"
                        valor={ formatTelefone( formValues.telefone ) }
                        changeFunc={ (e) => { 

                            let value = e.target.value
                            value = value.replace(/\D/g, '');

                            handleChange( value, 'telefone' )
                        }}
                    />
                    <FormComp
                        title="ESTADO DE ORIGEM"
                        type="select"
                        options={estadosBrasil}
                        valor={ formValues.estadoFrom }
                        changeFunc={ (e) => handleChange( e.target.value, 'estadoFrom' ) }
                    />
                    <FormComp
                        title="MUNICÍPIO DE ORIGEM"
                        type="select"
                        options={ municipios }
                        valor={ formValues.municipFrom }
                        changeFunc={ (e) => handleChange( e.target.value,'municipFrom' ) }
                    />
                    <FormComp
                        title="RECEBIMENTO DO CURRICULO"
                        type="date"
                        valor={ formValues.recebCurriculo }
                        changeFunc={ (e) => handleChange( e.target.value,'recebCurriculo' ) }
                    />
                    <FormComp
                        title="DATA CONTATO"
                        type="date"
                        valor={ formValues.dataContato }
                        changeFunc={ (e) => handleChange( e.target.value,'dataContato' ) }
                    />
                    <FormComp
                        title="CHEGADA"
                        type="date"
                        valor={ formValues.chegada }
                        changeFunc={ (e) => handleChange( e.target.value,'chegada' ) }
                    />
                    <FormComp
                        title="EXAME ADMISSIONAL"
                        type="date"
                        valor={ formValues.exameAdm }
                        changeFunc={ (e) => handleChange( e.target.value,'exameAdm' ) }
                    />

                    <FormComp
                        title="DOC. ADMISSÃO"
                        type="date"
                        valor={ formValues.docAdm }
                        changeFunc={ (e) => handleChange( e.target.value,'docAdm' ) }
                    />

                    <FormComp
                        title="DOC. SESMT"
                        type="date"
                        valor={ formValues.docSesmt }
                        changeFunc={ (e) => handleChange( e.target.value,'docSesmt' ) }
                    />
                    <FormComp
                        title="ADMISSÃO"
                        type="date"
                        valor={ formValues.admissao }
                        changeFunc={ (e) => handleChange( e.target.value,'admissao' ) }
                    />
                    <FormComp
                        title="CADASTRO PORTAL"
                        type="date"
                        valor={ formValues.cadPortal }
                        changeFunc={ (e) => handleChange( e.target.value,'cadPortal' ) }
                    />
                    <FormComp
                        title="INTEGRAÇÃO"
                        type="date"
                        valor={ formValues.integracao }
                        changeFunc={ (e) => handleChange( e.target.value,'integracao' ) }
                    />
                    <FormComp
                        title="ENTRADA NO SITE"
                        type="date"
                        valor={ formValues.entradaSite }
                        changeFunc={ (e) => handleChange( e.target.value,'entradaSite' ) }
                    />
                    <FormComp
                        title="NÚMERO UNIFORME"
                        type="select"
                        options={[
                            "P", "M", "G", "GG", "EXG"
                        ]}
                        valor={ formValues.numUniforme }
                        changeFunc={ (e) => handleChange( e.target.value,'numUniforme' ) }
                    />
                    <FormComp
                        title="SALÁRIO"
                        type="number"
                        valor={ formValues.salario }
                        changeFunc={ (e) => handleChange( e.target.value,'salario' ) }
                    />
                    <FormComp
                        title="NÚMERO CALÇADO"
                        type="number"
                        valor={ formValues.numCalcado }
                        changeFunc={ (e) => handleChange( e.target.value,'numCalcado' ) }
                    />

                    <button type="submit" disabled={bloqueado}>
                        SALVAR
                    </button>

                </Formulario>

            </div>
            {loading && (
                <Overlay state={ true } >
                    <Modal size='sm' >
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </div>
        </Modal>
        </Overlay>

    )

}

export default SquareAdmis;